<va-button btnType="outline" size="medium" (click)="showColumnPicker()">
  Column Picker
</va-button>

<nz-modal
  nzWrapClassName="vertical-center-modal"
  nzClassName="charts-modal-container"
  [(nzVisible)]="isVisible"
  nzTitle="Column Picker"
  [nzFooter]="null"
  nzWidth="950px"
  (nzOnCancel)="onCancel()"
>
  <ng-container *nzModalContent>
    <va-item-picker
    [items]="currentItems"
    [addItemsHeader]="'Available columns'"
    [selectedItemsHeader]="'Selected columns'"
    [showResetBtn]="false"
    (onApply)="onApply($event)"
    (onAddItem)="onAddItem($event)"
    (onAddAllItems)="onAddAllItems()"
    (onDragItem)="onDragItem($event)"
    (onCancel)="onCancel()"
    (onRemoveItem)="onRemoveItem($event)"
    (onRemoveAllItems)="onRemoveAllItems()"
  >
  </va-item-picker>
  </ng-container>
</nz-modal>
